/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState, useContext } from "react";
import "./ShareFormModal.scss";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import { Button, Table, Form, Modal } from "react-bootstrap";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import { RegulationContext } from "../../../App";
import { FcFinePrint } from "react-icons/fc";

import {
  DEFAULT_ITEMS_PER_PAGE,
  SORT_ORDER_DESC,
  LIST_DEF_SORT,
  RiskReportFrequency,
  STATUS
} from "../../../core/constants/common";
import FormService from "../../../core/service/FormService";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import nodataimg from "../../../images/nodatafound.png";
import DatePicker from "react-datepicker";
import ReportingPeriod from "../../../components/Regulation/ReportingPeriod";

const ShareFormModal = ({ t, isShare, list, callbackShare }) => {
  const [show, setShow] = useState(isShare ? true : false);
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [forms, setForms] = useState([]);
  const [formsToShare, setFormsToShare] = useState([]);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [messageConfirmation, setMessageConfirmation] = useState("");
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";

  const reportingPeriodOptions = RiskReportFrequency({ t });

  const handleClose = () => {
    setShow(false);
    callbackShare(false);
  };
  const searchKey = "";
  const handleShow = () => setShow(true);
  useEffect(() => {
    if (glbRegulationId) {
      getForms(0, itemsPerPage, searchKey, sortField, glbRegulationId);
    } else {
      getForms(0, itemsPerPage, searchKey, sortField);
    }
  }, [isShare, list]);
  const getForms = (
    pageNumber,
    itemsPerPageVal,
    searchVal = "",
    sortField,
    glbRegulationId = ""
  ) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }
    var sort = sortField + "," + order;
    let selfAssessment = false;
    FormService.listFormsForSharing(glbRegulationId, "PUBLISHED", selfAssessment)
      .then((response) => {
        setForms([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        // console.log("err", error);
      });
  };
  const handleFormCheck = (e) => {
    const { id, checked } = e.target;
    if (checked) {
      setFormsToShare([
        ...formsToShare,
        {
          formId: +id,
          reportingPeriod: '',
          lastSubmissionDate: new Date()
        }
      ]);
    } else {
      setFormsToShare(formsToShare.filter(f => +f.formId !== +id));
    }
  };

  const setReportingPeriod = (formId, period) => {
    const data = [...formsToShare];
    data.forEach(d => {
      if (d.formId === formId) {
        d.reportingPeriod = new Date(period.year + '-' + period.month + '-01');
      }
    });
    setFormsToShare(data);
  };

  const setlastSubmissionDate = (formId, date) => {
    const data = [...formsToShare];
    data.forEach(d => {
      if (d.formId === formId) {
        d.lastSubmissionDate = date;
      }
    });
    setFormsToShare(data);
  };

  const handleShare = () => {
    if (glbRegulationId) {
      var params = {
        forms: formsToShare,
        supplierIds: list,
        regulationId: glbRegulationId,
      };
      if (list.length === 0) {
        setShow(false);
        setIsConfirmation(true);
        setMessageConfirmation(t("SelectSupplierWarning.label"));
      } else if (formsToShare.length === 0) {
        setShow(false);
        setIsConfirmation(true);
        setMessageConfirmation(t("SelectFormWarning.label"));
      } else {
        FormService.shareForms(params)
          .then((response) => {
            if (response.status === 200) {
              toast.success("Success", {
                position: toast.POSITION.TOP_RIGHT,
              });
              setShow(false);
              callbackShare(false);
            }
          })
          .catch((error) => {
            //ErrorHandlingService.handleError(error.response.status);
          });
      }
    } else {
      setShow(false);
      setIsConfirmation(true);
      setMessageConfirmation(t("SelectRegulationWarning.label"));
    }
  };
  const callbackModal = (boolVal) => {
    setIsConfirmation(false);
    callbackShare(false);
  };

  return (
    <>
      {isConfirmation && (
        <ConfirmationModal
          modalShow={true}
          messageText={messageConfirmation}
          callbackModal={callbackModal}
        />
      )}
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          < Modal.Title as="h5">
            {t("ShareAssessments.label")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Table responsive="sm">
              <thead>
                <tr>
                  <th></th>
                  <th>{t("AssessmentTitle.label")}</th>
                  <th>{t("Description.label")}</th>
                </tr>
              </thead>
              <tbody>
                {forms?.length > 0 ? (
                  forms?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <Form.Check
                          inline
                          name={item.id}
                          type="checkbox"
                          id={item.id}
                          onChange={handleFormCheck}
                        />
                      </td>
                      <td>
                        {item.name}
                        <p className="m-0">
                          {item.regulation && item.regulation.name}
                        </p>
                      </td>
                      <td>
                        {item.description}
                        {
                          formsToShare.findIndex(f => f.formId === +item.id) >= 0 &&
                          <div className="row pt-2">
                            <div className="col-md-6">
                              <div>
                                <label className="mb-1">{t("ReportingPeriod.label")} *</label>
                                <ReportingPeriod valueChangeCallback={(data) => setReportingPeriod(+item.id, data)} />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div>
                                <div>
                                  <label className="mb-1">{t("LastSubmissionDate.label")} *</label>
                                  <DatePicker
                                    selected={formsToShare.find(f => f.formId === +item.id)?.lastSubmissionDate}
                                    onChange={(date) => setlastSubmissionDate(+item.id, date)}
                                    className="form-control"
                                    required
                                    dateFormat="dd/MM/yyyy"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleShare}>
            {t("Share.label")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withTranslation()(ShareFormModal);
